<template>
    <DuplicatePart></DuplicatePart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const DuplicatePart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/PartMaintenance/DuplicatePart.vue"
    )
);

export default {
    name: "Project_HelpDuplicatePart", //The name you are in should not equal the name of the component you are importing.
    components: { DuplicatePart, AuthLayout },
};
</script>
